import React, { useEffect, useRef, useState } from 'react'
import EditMenu from '../editMenu'
import { withTheme } from 'theming'
// import { Link } from 'react-router-dom'
import AddSection from '../addSection'
import useTemplateHook from '../templateHook'
import CustomImage from '../../customImage/customImage'
import { isEmpty } from 'lodash'
import SearchIcon from '../imgComponents/searchIcon'
import styled from '@emotion/styled'
import NavBarDropDown from '../../navbarDropdown'
import MobileNavDropDown from '../../mobileNavDropDown'

const StyledListItem = styled.li`
  .dropdown-list {
    background-color: ${(props) => props.background};
    transition: background-color 0.4s ease-in-out;
  }
  .dropdown-list:hover {
    background-color: ${(props) => props.backgroundHover};
  }
  .dropdown-list:hover {
    border-radius: ${(props) => props.borderRadius};
  }
`

const StyledDropdownMenu = styled.ul`
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out;
  transition-delay: ${(props) => (props.isOpen ? '0.4s' : '0s')};
`

const StyledMenuWrapper = styled.div`
  .header-menu-underline {
    position: relative;
    display: inline-block;
    text-decoration: none !important;
  }

  .header-menu-underline::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -5px;
    width: 100%;
    height: 2px;
    background-color: transparent;
    transition: background-color 0.4s ease-in-out;
  }

  &:hover .header-menu-underline::after {
    background-color: ${(props) => props.highlightColor};
  }

  .header-menu-underline.active-underline::after {
    background-color: ${(props) => props.highlightColor};
  }
`

const NewRightHeader = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onDelete,
  theme,
  onAdd,
  onSwap,
}) => {
  const { data, id } = componentData
  const [profileToggle, setProfileToggle] = useState(false)
  const [openMobileMenu, setOpenMobileMenu] = useState(false)
  const {
    customNavigate,
    isLogin,
    userObj,
    // logoutCall,
    // handleSubscription,
    getTemplateImage,
    fitnessHeaderPadding,
  } = useTemplateHook()
  const [hoverState, setHoverState] = useState('')
  const [searchText, setSearchText] = useState('')

  const inputRef = useRef(null)

  const [drops, setDrops] = useState(data.site_map.map((dat) => ({ opened: false })))

  const handleDropDown = (selectedDropDownIndex) => {
    let tempDrops = drops
    if (tempDrops[selectedDropDownIndex].opened) tempDrops[selectedDropDownIndex].opened = false
    else tempDrops[selectedDropDownIndex].opened = true
    setDrops([...tempDrops])
  }

  const handleBlurDropDown = (blurDropDownIndex) => {
    let tempDrops = drops
    tempDrops[blurDropDownIndex].opened = false
    setDrops([...tempDrops])
  }

  useEffect(() => {
    setDrops(data.site_map.map((dat) => ({ opened: false })))
  }, [data])

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }
  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleSearchButton = () => {
    if (searchText) {
      customNavigate('DIRECT', `search?search_text=${searchText}`, isEdit)
      // setOpenMobileSearch(false)
      setSearchText('')
      setOpenMobileMenu(false)
    }
  }

  const handleSearch = (event) => {
    if (event.key === 'Enter' && searchText) {
      customNavigate('DIRECT', `search?search_text=${searchText}`, isEdit)
      setSearchText('')
      setOpenMobileMenu(false)
    }
  }

  const handleRedirect = (linkObj) => {
    setOpenMobileMenu(false)
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <>
      <header
        className={` ${isEdit ? 'fixed' : 'fixed'} z-50 w-full ${
          isEdit && hoverState && 'component-hover-class'
        } h-[60px] md:h-[68px]`}
        onMouseEnter={() => handleHoverItems(`TOP`)}
        onMouseLeave={() => handleHoverItems('')}
      >
        {isEdit && hoverState.length > 0 && (
          <EditMenu
            onEdit={handleModal}
            onDelete={() => onDelete(id)}
            onMoveUp={() => onSwap(id, 'up')}
            onMoveDown={() => onSwap(id, 'down')}
          />
        )}
        <nav
          style={{
            backgroundColor: `${getStyleValue('component_background', 'primary_color', '#000000')}`,
          }}
          className={` px-[8px] lg:px-4 2xl:px-[2vw] py-2.5 w-full `}
        >
          <div className="flex items-center justify-between mx-auto max-w-screen-auto">
            {/* LEFT SIDE: Logo and Search */}
            <div className="flex items-center gap-4 z-0">
              <div className="mr-4 ml-3" onClick={() => customNavigate('DIRECT', '/home', isEdit)}>
                <CustomImage
                  imageUrl={getTemplateImage(data?.logo_s3key)}
                  imgClass=" h-6 w-[65px] sm:h-12 xl:w-28 cursor-pointer"
                  imgStyle={{ backgroundColor: 'transparent' }}
                  loaderClass="h-8 sm:h-12 cursor-pointe"
                  loaderStyle={{ background: '#5A5A5A50' }}
                  imgAlt={'Logo'}
                />
              </div>

              {/* Search Input */}
              <div className="hidden xl:flex items-center relative">
                <input
                  ref={inputRef}
                  type="text"
                  className="flex-shrink-0 outline-none  px-2 xl:py-3 lg:py-1.5 py-[0] w-full 
                  text-xs 2xl:text-[13px]
                  placeholder:italic"
                  style={{
                    borderRadius: '6px',
                    backgroundColor: getStyleValue('search_input', 'background_color', '#2E2E2E'),
                    color: getStyleValue('search_input', 'text_color', '#ffffff'),
                    width: '218px',
                    paddingLeft: '35px',
                  }}
                  disabled={isEdit}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyPress={(e) => handleSearch(e)}
                />
                <div className="absolute left-2 cursor-pointer" onClick={handleSearchButton}>
                  <SearchIcon
                    color={getStyleValue('search_input', 'icon_color', '#fff')}
                    imgStyle={{ width: '18px', height: '18px' }}
                  />
                </div>
              </div>
            </div>

            {/* RIGHT SIDE: Navigation Menu and Auth Buttons */}
            <div className="flex items-center gap-4">
              {/* Navigation Menu */}
              <div
                className="hidden justify-between items-center xl:flex lg:w-auto"
                id="mobile-menu-2"
              >
                <ul
                  style={{ listStyle: 'none', margin: 0, padding: 0 }}
                  className="flex items-center"
                >
                  {data?.site_map.map((siteMapItem, idx) => (
                    <StyledMenuWrapper
                      key={idx}
                      className="group xl:relative static h-full"
                      highlightColor={getStyleValue('highlighter_color', 'color', '#fecc00')}
                      onClick={
                        siteMapItem?.link?.type.length > 0
                          ? () => handleRedirect(siteMapItem?.link)
                          : () => handleDropDown(idx)
                      }
                      onMouseEnter={
                        siteMapItem?.link?.type.length > 0 ? () => {} : () => handleDropDown(idx)
                      }
                      onMouseLeave={() => handleBlurDropDown(idx)}
                      onBlur={(e) => {
                        const currentTarget = e.currentTarget
                        // Give browser time to focus the next element
                        requestAnimationFrame(() => {
                          // Check if the new focused element is a child of the original container
                          if (!currentTarget.contains(document.activeElement)) {
                            // setShowsDropdown(false)
                            handleBlurDropDown(idx)
                          }
                        })
                      }}
                      tabIndex={100}
                    >
                      <button
                        className={`text-xs 2xl:text-[13px] px-1.5 2xl:px-[1vw]  cursor-pointer  xl:w-max w-full flex xl:justify-start justify-center items-center`}
                        style={{
                          border: 'none',
                          color: getStyleValue('title_primary', 'color', 'white'),
                          background: 'transparent',
                        }}
                      >
                        <span
                          className={`${
                            drops[idx]?.opened ? 'active-underline' : ''
                          } ${getStyleValue(
                            'title_primary',
                            'font_format',
                            '',
                          )}  header-menu-underline`}
                          style={{
                            fontFamily: getStyleValue('title_primary', 'font', ''),
                          }}
                        >
                          {siteMapItem?.title}
                        </span>
                        {siteMapItem?.sub_heading_data.some((item) => item.text.length > 0) && (
                          <svg
                            className={`${
                              drops[idx]?.opened ? 'rotate-profile-arrow' : 'reset-profile-arrow'
                            } w-3 h-3 ml-1`}
                            style={{
                              transition: 'transform 0.4s ease-in-out',
                            }}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        )}
                      </button>
                      <div style={{ height: '22px' }} className="absolute w-full" />
                      <StyledDropdownMenu
                        isOpen={drops[idx]?.opened}
                        className={` absolute w-auto`}
                        style={{
                          paddingInlineStart: '0',
                          borderRadius: '6px',
                          overflow: 'hidden',
                          marginBottom: '0',
                          color: '#fff',
                          marginTop: '22px',
                          whiteSpace: 'nowrap',
                          listStyle: 'none',
                          minWidth: '90%',
                        }}
                      >
                        {siteMapItem?.sub_heading_data.map((item, idx) => {
                          return (
                            item?.text.length > 0 && (
                              <StyledListItem
                                key={idx}
                                background={`${getStyleValue(
                                  'component_background',
                                  'primary_color',
                                  '#000000',
                                )}`}
                                backgroundHover={`${getStyleValue(
                                  'highlighter_color',
                                  'color',
                                  '#fecc00',
                                )}`}
                                borderRadius="6px"
                              >
                                <li
                                  className={`dropdown-list cursor-pointer w-full h-max flex xl:justify-start text-xs 2xl:text-[13px] items-center py-2.5 xl:pl-6 pl-0 xl:pr-6 pr-0  hover:text-white ${getStyleValue(
                                    'title_secondary',
                                    'font_format',
                                    '',
                                  )}`}
                                  style={{
                                    color: getStyleValue('title_secondary', 'color', 'white'),
                                    fontFamily: getStyleValue('title_secondary', 'font', ''),
                                  }}
                                  key={idx}
                                  onClick={() => {
                                    // handleCategoryClick(item._id, item.name)
                                    handleRedirect(item?.link)
                                  }}
                                >
                                  {item.text}
                                </li>
                              </StyledListItem>
                            )
                          )
                        })}
                      </StyledDropdownMenu>
                    </StyledMenuWrapper>
                  ))}
                </ul>
              </div>

              {/* Vertical Line Separator */}
              <div
                className="hidden xl:block h-4"
                style={{
                  borderLeft: `1px solid ${getStyleValue('add_btn1', 'color', '#fff')}`,
                }}
              />

              {/* Auth Buttons or Profile */}
              {!isLogin ? (
                <div className="hidden xl:flex items-center gap-5">
                  <span
                    onClick={() => handleRedirect(data?.add_btn1?.link)}
                    className="cursor-pointer text-xs 2xl:text-[13px]"
                    style={{
                      color: getStyleValue('add_btn1', 'color', 'white'),
                    }}
                  >
                    {data?.add_btn1?.text}
                  </span>

                  <button
                    onClick={() => handleRedirect(data?.add_btn2?.link)}
                    style={{
                      backgroundImage: `linear-gradient(to ${getStyleValue(
                        'add_btn2',
                        'gradient',
                        'right',
                      )}, ${getStyleValue('add_btn2', 'primary_color', 'white')}, ${getStyleValue(
                        'add_btn2',
                        'secondary_color',
                        'white',
                      )})`,
                      color: getStyleValue('add_btn2', 'text_color', 'white'),
                      borderRadius: '6px',
                    }}
                    className="border-0 shadow-xl font-semibold text-xs 2xl:text-[13px] px-6 md:py-2.5 mr-3"
                  >
                    {data?.add_btn2?.text}
                  </button>
                </div>
              ) : (
                <div
                  className="flex justify-center items-center"
                  onClick={() => {
                    setProfileToggle(!profileToggle)
                    setOpenMobileMenu(false)
                  }}
                  onBlur={(e) => {
                    const currentTarget = e.currentTarget
                    // Give browser time to focus the next element
                    requestAnimationFrame(() => {
                      // Check if the new focused element is a child of the original container
                      if (!currentTarget.contains(document.activeElement)) {
                        setProfileToggle(false)
                        setOpenMobileMenu(false)
                      }
                    })
                  }}
                  tabIndex={3}
                >
                  <div className="relative">
                    <div className="flex justify-center items-center space-x-2 xl:mr-3 cursor-pointer">
                      <div
                        style={{
                          width: '22px',
                          height: '22px',
                          borderRadius: '5px',
                          backgroundImage: 'linear-gradient(319deg, #dd5e89 18%, #f7bb97 86%)',
                        }}
                        className="text-uppercase font-bold text-xs flex justify-center items-center"
                      >
                        {`${userObj.name}`.substring(0, 1)}
                      </div>

                      <div>
                        <div
                          style={{ opacity: '0.85' }}
                          className="flex text-xs 2xl:text-[13px] text-white"
                        >
                          <span>{userObj?.name ? userObj?.name.split(' ')[0] : ''}</span>
                          <svg
                            className={
                              profileToggle
                                ? 'rotate-profile-arrow w-3 h-3 ml-1 mt-1'
                                : 'reset-profile-arrow w-3 h-3 ml-1 mt-1'
                            }
                            style={{
                              transition: 'transform 0.4s ease-in-out',
                            }}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    {profileToggle ? (
                      <NavBarDropDown
                        backgroundColor={`${getStyleValue(
                          'component_background',
                          'primary_color',
                          '#000000',
                        )}`}
                        titleColor={getStyleValue('title_primary', 'color', 'white')}
                      />
                    ) : null}
                  </div>
                </div>
              )}

              {!isLogin && (
                <div className="xl:hidden flex items-center gap-3">
                  <span
                    onClick={() => handleRedirect(data?.add_btn1?.link)}
                    className="cursor-pointer text-xs"
                    style={{
                      color: getStyleValue('add_btn1', 'color', 'white'),
                    }}
                  >
                    {data?.add_btn1?.text}
                  </span>

                  <button
                    onClick={() => handleRedirect(data?.add_btn2?.link)}
                    style={{
                      backgroundImage: `linear-gradient(to ${getStyleValue(
                        'add_btn2',
                        'gradient',
                        'right',
                      )}, ${getStyleValue('add_btn2', 'primary_color', 'white')}, ${getStyleValue(
                        'add_btn2',
                        'secondary_color',
                        'white',
                      )})`,
                      color: getStyleValue('add_btn2', 'text_color', 'white'),
                      borderRadius: '6px',
                    }}
                    className="border-0 shadow-xl font-semibold text-xs px-4 py-2"
                  >
                    {data?.add_btn2?.text}
                  </button>
                </div>
              )}

              {/* Mobile Menu Icon */}
              <button
                type="button"
                className="xl:hidden flex items-center py-2 px-1  rounded-lg border-0"
                onClick={() => {
                  setOpenMobileMenu(!openMobileMenu)
                  setProfileToggle(false)
                }}
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ fill: '#ffffff' }}
                >
                  <path
                    fillRule="evenodd"
                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          <div
            className={openMobileMenu && !profileToggle ? 'w-full' : 'w-full'}
            style={{
              borderBottom: openMobileMenu && !profileToggle ? `0.5px solid #ffffff` : 'none',
              backgroundColor: `${getStyleValue(
                'component_background',
                'primary_color',
                '#000000',
              )}`,
              transition: 'all 0.3s ease-in-out',
              opacity: openMobileMenu && !profileToggle ? 1 : 0,
              maxHeight: openMobileMenu && !profileToggle ? '600px' : '0',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            {/* Main menu view */}
            <div
              style={{
                transition: 'all 0.3s ease-in-out',
                opacity: !drops.some((drop) => drop.opened) ? 1 : 0,
                position: !drops.some((drop) => drop.opened) ? 'relative' : 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                pointerEvents: !drops.some((drop) => drop.opened) ? 'auto' : 'none',
              }}
            >
              <ul className="divide-y">
                {data?.site_map.map((siteMapItem, idx) => (
                  <div
                    key={idx}
                    className="group xl:relative static h-full py-2 "
                    style={{
                      borderTop: `0.5px solid #ffffff`,
                    }}
                    onBlur={(e) => {
                      const currentTarget = e.currentTarget
                      // Give browser time to focus the next element
                      requestAnimationFrame(() => {
                        // Check if the new focused element is a child of the original container
                        if (!currentTarget.contains(document.activeElement)) {
                          // setShowsDropdown(false)
                          handleBlurDropDown(idx)
                        }
                      })
                    }}
                    tabIndex={100}
                  >
                    <button
                      className={`xl:w-max w-full flex  gap-2 items-center`}
                      style={{
                        border: 'none',
                        color: getStyleValue('title_primary', 'color', '#ffffff'),
                        padding: '0 40px',
                      }}
                      onClick={
                        siteMapItem?.link?.type.length > 0
                          ? () => handleRedirect(siteMapItem?.link)
                          : () => handleDropDown(idx)
                      }
                    >
                      <span
                        className={`${getStyleValue('title_primary', 'font_format', '')} text-xs`}
                        style={{
                          fontFamily: getStyleValue('title_primary', 'font', ''),
                        }}
                      >
                        {siteMapItem?.title}
                      </span>
                      {siteMapItem?.sub_heading_data.some((item) => item.text.length > 0) && (
                        <svg
                          className="w-3 h-3"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      )}
                    </button>
                  </div>
                ))}
              </ul>
            </div>

            {/* Submenu view */}
            <div
              style={{
                transition: 'all 0.3s ease-in-out',
                opacity: drops.some((drop) => drop.opened) ? 1 : 0,
                position: drops.some((drop) => drop.opened) ? 'relative' : 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                pointerEvents: drops.some((drop) => drop.opened) ? 'auto' : 'none',
              }}
            >
              {data?.site_map.map(
                (siteMapItem, idx) =>
                  drops[idx]?.opened && (
                    <div key={idx}>
                      {/* Submenu Header with Back Arrow */}
                      <div
                        className={`w-full flex items-center ${getStyleValue(
                          'title_primary',
                          'font_format',
                          '',
                        )} text-xs py-2 px-3`}
                        style={{
                          backgroundHover: getStyleValue('highlighter_color', 'color', '#fecc00'),
                          borderTop: `0.5px solid #ffffff`,
                        }}
                      >
                        <button
                          className="flex items-center"
                          style={{
                            border: 'none',
                            background: 'transparent',
                            color: getStyleValue('title_primary', 'color', 'white'),
                          }}
                          onClick={() => handleBlurDropDown(idx)}
                        >
                          <svg
                            className="w-3 h-3 mr-1"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M15 19l-7-7 7-7"
                            />
                          </svg>
                          <span
                            style={{
                              fontFamily: getStyleValue('title_primary', 'font', ''),
                            }}
                            className="text-xs"
                          >
                            {siteMapItem?.title}
                          </span>
                        </button>
                      </div>

                      {/* Submenu Items */}
                      <ul
                        style={{
                          paddingInlineStart: '0',
                          marginBottom: '0',
                          color: getStyleValue('title_secondary', 'color', '#ffffff'),
                        }}
                      >
                        {siteMapItem?.sub_heading_data.map((item, subIdx) => {
                          return (
                            item?.text.length > 0 && (
                              <li
                                className={`cursor-pointer w-full h-max flex justify-start text-xs items-center py-2 hover:text-white ${
                                  getStyleValue('title_secondary', 'font_format')
                                    ? getStyleValue('title_secondary', 'font_format')
                                    : ''
                                }`}
                                style={{
                                  fontFamily: getStyleValue('title_secondary', 'font', ''),
                                  paddingLeft: '40px',
                                  borderTop: '0.5px solid #ffffff',
                                  transition: 'background-color 0.2s ease-in-out',
                                }}
                                key={subIdx}
                                onClick={() => {
                                  handleRedirect(item?.link)
                                }}
                              >
                                {item.text}
                              </li>
                            )
                          )
                        })}
                      </ul>
                    </div>
                  ),
              )}
            </div>
          </div>

          {/* Mobile Profile Menu */}
          <div
            className="w-full xl:hidden"
            style={{
              borderBottom: profileToggle && !openMobileMenu ? `0.5px solid #ffffff` : 'none',
              backgroundColor: `${getStyleValue(
                'component_background',
                'primary_color',
                '#000000',
              )}`,
              transition: 'all 0.3s ease-in-out',
              opacity: profileToggle && !openMobileMenu ? 1 : 0,
              height: profileToggle && !openMobileMenu ? 'auto' : '0',
              overflow: 'hidden',
            }}
          >
            <MobileNavDropDown
              titleColor={getStyleValue('title_primary', 'color', 'white')}
              borderTop={`1.5px solid ${getStyleValue('add_btn1', 'color', theme.c5)}`}
              isLeftAligned={true}
              useWhiteBorder={true}
            />
          </div>
        </nav>
        {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
      </header>
      <div className={`${!fitnessHeaderPadding && 'hidden'} lg:px-14 py-6 w-full`}>{`.`}</div>
    </>
  )
}

export default withTheme(NewRightHeader)
